<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md8 sm11>
          <h3 class="text-center">Coupons</h3>
          <v-card>
            <v-card-title class="py-0">
              <v-text-field label="Search" dense single-line hide-details v-model="filterBy" prepend-icon="search" :disabled="coupons.length < 1" :append-icon="filterBy.length > 0 ? 'close' : ''" @click:append="() => (filterBy = '')"></v-text-field>
              <v-spacer></v-spacer>
              <v-btn outlined small href="/coupons/create" @click.stop.prevent="goTo('/coupons/create')" v-show="canCreate">
                <v-icon left>mdi-qrcode-plus</v-icon>
                Add New
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="coupons" :search="filterBy" dense :headers="headers">
                <template v-slot:[`item.code`]="{ item }">
                  <span v-if="item.deleted_at" v-text="item.code"></span>
                  <inertia-link :href="'/coupons/' + item.id" v-text="item.code" v-else></inertia-link>
                </template>
                <template v-slot:[`item.deleted_at`]="{ item }">
                  <span v-if="item.deleted_at">
                    <v-btn icon title="Restore this coupon" color="warning" @click="restore(item)">
                      <v-icon>mdi-recycle</v-icon>
                    </v-btn>
                  </span>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions class="py-0">
              <v-spacer></v-spacer>
              <inertia-link :href="loadDeleted ? '/coupons' : '/coupons?load_all=deleted'">Load {{ loadDeleted ? 'active' : 'deleted' }}</inertia-link>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'Coupons',
    layout,
    props: [
      'coupons',
      'canCreate',
      'deleted'
    ],
    components: {},
    metaInfo () {
      return {
        title: 'Coupons',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        headers: [
          {
            text: 'Code', value: 'code',
          },
          {
            text: 'Discount (%)', value: 'discount', align: 'right',
          },
          {
            text: 'Expiry', value: 'expiry',
          },
          {
            text: 'Used', value: 'used', align: 'right',
          },
          {
            text: 'Limit', value: 'limit', align: 'right',
          },
          {
            text: '', value: 'deleted_at', align: 'right', sortable: false
          }
        ],
        filterBy: '',
      }
    },
    methods: {
      restore (coupon) {
        swal({
          title: coupon.code,
          text: 'Restore this coupon?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'orange',
          confirmButtonText:'Restore',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.$inertia.post('/coupons/restore', {
            id: coupon.id,
          }, {
            onFinish: () => {
              swal.close()
            }
          })
        }.bind(this))
      },
    },
    computed: {
      loadDeleted () {
        return this.deleted == 'deleted'
      }
    },
  }
</script>
